<template>
	<div class="main2 groupEdit">
		<div class="table-form">
			<div class="form-title" v-if = "$route.query.id">修改分组</div>
			<div class="form-title" v-else>新建分组</div>
			<form action="javascript:void(0)" method="post">
				<label>分组名称:</label>
				<input type="text" class = "groupname" name="groupname" v-model="groupname" value="" placeholder="填写名称" />
				<div class="tipCommon"></div>
				<label>子组:</label>
				<Dropdown  :data="data1" grouped multiple :width="580" :cbItemChanged="changed1" :cbCustomSelectedText="customSelectedGroup" :placeholder = "'选择子分组'"></Dropdown>
				<label>组员:</label>
				<Dropdown ref="child" :data="data2" multiple grouped :width="580" :cbItemChanged="changed2" :cbCustomSelectedText="customSelectedText" :placeholder = "'选择分组成员'"></Dropdown>
				<!--<input type="text" name="userAddname" id="userAddname" value="" placeholder="填写姓名" />-->
				<label>备注</label>
				<textarea class="instruction act"  name="gdetail" rows="" cols="" v-model="gdetail" ></textarea>
				<div class="formBtn-group">
					<div class="cancel-btn" @click="goBack">取消</div>
					<input type="submit" class="submit-btn" name="submitBtn" id="submitBtn" @click="groupAdd" value="提交" />
				</div>
			</form>
		</div>
		<div class = "login-copyright"> © 2018 zhiyun-tech.com All rights reserved.   桂林智神信息技术有限公司 桂ICP备15010724号-1</div>
	</div>
</template>

<script>
	import Dropdown from '@/components/Dropdown'
	import checkBox from '@/components/checkBox'
	export default {
		name: 'groupEdit',
		data() {
			return {
				data1:[{
					label:"",
					children:{}
				}],
				data2:[{
					label:"",
					children:{}
				}],
				groupname:"",
				gdetail:"",
				groupIds:"",
				userIds:""
			}
		},
		components: {
			Dropdown,
			checkBox
		},
		created: function() {
			this.$nextTick(() => {
				this.common.get('user/showAllUser', this.getUser,{},false);
				if(this.$route.query.id){
					this.common.get('group/showAllGroupNotContentsSelf?id='+this.$route.query.id, this.getGroup,{},false);
					this.common.get('group/queryById?id='+this.$route.query.id, this.editCreate,{},false);
				}else{
					this.common.get('group/showAllGroup', this.getGroup,{},false);
				}
			})
		},
		mounted: function() {
			
		},
		methods: {
			editCreate:function(data){
				if(data!=null){
					this.groupname = data.groupInfo[0].groupname;
					this.gdetail  = data.groupInfo[0].remark;
					this.data1[0].children = this.$refs.child.setData(this.data1[0].children,data.subGroupNames,true)
					this.data2[0].children = this.$refs.child.setData(this.data2[0].children,data.members,true)
				}
			},
			goBack: function() {
				location.href = "/groupList"
			},
			
			getGroup:function(data){
				this.data1 = this.$refs.child.renderData("groupname",data,"分组"); 
//				if(!this.$route.query.id){
//					this.data1[0].children[0].selected = true
//				}
			},
			getUser:function(data){
				this.data2 = this.$refs.child.renderData("nickname",data,"组员");
			},
			groupAdd: function() {
				let params = {}
				let _this = this;
				if(this.groupname==""){
					return this.layer.alert("请填写分组名称");
				}
//				if(this.parentgroupid==""){
//					return this.layer.alert("请选择父组");
//				}
//				if(this.userIds==""){
//					return this.layer.alert("请选择组员");
//				}
				if(this.remark==""){
					return this.layer.alert("请填写备注");
				}
				if(this.$route.query.id){
					params.id =this.$route.query.id
				}else{
					let validateGroupname = true;
					this.common.get("group/validateGroupname",function(res){
						if(res.errcode!=0){
							_this.layer.alert(res.errmsg);
							validateGroupname = false;
						}
					},{groupname:this.groupname},false)
					if(validateGroupname==false){
						return false;
					}
				}
				params.groupname = this.groupname
				params.childIds = this.groupIds
				params.userIds = this.userIds
				params.remark = this.gdetail
				if(!this.$route.query.id){
					this.common.post('group/addGroup', this.userAddResult,params,false);
				}else{
					this.common.post('group/editGroups', this.userAddResult,params,false);
				}
			},
			userAddResult:function(data){
				if(data.errcode==11000000){
					this.layer.alert(data.errmsg)
				}else if(data.errcode==0){
					this.layer.alert("成功",function(){
						location.href = "/groupList"
					})
				}else{
					this.layer.alert(data.errmsg)
				}
			},
			changed2(item) {
				if(item.label !== 'All') return
				let copy = JSON.parse(JSON.stringify(data1))
				copy.forEach(d => !d.disabled && (d.selected = item.selected))
				this.data1 = copy
			},
			customSelectedText(selected, defaultFn) {
				let hasAll = false
				selected.every((s) => {
					if(s.label === 'All') {
						hasAll = true
						return false
					}
					return true
				})
				if(hasAll) {
					return 'All'
				}
				this.userIds = selected.map((e) => e.value).join("&&");
				return defaultFn(selected)
			},
			changed1(item) {
				if(item.label !== 'All') return
				let copy = JSON.parse(JSON.stringify(data1))
				copy.forEach(d => !d.disabled && (d.selected = item.selected))
				this.data1 = copy
			},
			customSelectedGroup(selected, defaultFn) {
				let hasAll = false
				selected.every((s) => {
					if(s.label === 'All') {
						hasAll = true
						return false
					}
					return true
				})
				if(hasAll) {
					return 'All'
				}
				
				this.groupIds = selected.map((e) => e.value).join("&&");
				return defaultFn(selected)
			}
		}

	}
</script>

<style>
	@import url("../../static/bower_components/Font-Awesome/css/font-awesome.css");
	@import url("../../static/css/editForm.css");
	
</style>


// WEBPACK FOOTER //
// src/assets/groupEdit.vue